export default "__VITE_ASSET__Cr0uSQ39__"